import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { PaymentsSettings } from '../../../settings-data/sub-models/company-settings/payments.model';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Component({
  selector: 'app-payments-markup',
  templateUrl: './payments-markup.component.html',
  styleUrls: ['./payments-markup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsMarkupComponent implements OnInit {
  @Input() buttonCta: string;
  @Input() hasBankTransfer: boolean;
  @Input() hasCardPayments: boolean;
  @Input() hasPaypalEc: boolean;
  @Input() paymentsSettings: PaymentsSettings;
  @Input() paymentNotificationsText: SafeHtml;

  paypalIcon: IIcon;
  bankTransferIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.paypalIcon = {
      name: 'card-paypal',
      size: IconSizesEnum.custom,
    };
    this.bankTransferIcon = {
      name: 'card-bank-transfer',
      size: IconSizesEnum.custom,
    };
  }
}
